import { NgModule } from '@angular/core';
import { AngularCreatePdfService } from './angular-create-pdf.service';

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [AngularCreatePdfService]
})
export class AngularCreatePdfModule { }
